import React from 'react'
import { Box, Typography } from '@mui/material'
import type { InterestVerdict } from 'api/league'
import { VERDICT_CONFIG } from 'constants/interest'
import { getScoreColor } from 'utils/scoreColor'
import RIcon from 'components/structure/RIcon'

interface Props {
  score: number
  verdict: InterestVerdict
}

/** Compact rectangular score chip for the card header row. */
const InterestScoreBadge: React.FC<Props> = ({ score, verdict }) => {
  const cfg = VERDICT_CONFIG[verdict] ?? VERDICT_CONFIG.ok
  const color = getScoreColor(score)

  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.55,
        px: 1,
        py: 0.45,
        borderRadius: 1.25,
        flexShrink: 0,
        backgroundColor: cfg.trackColor,
        border: `1.5px solid ${color}55`,
        boxSizing: 'border-box',
      }}
      aria-label={`Interest score ${score}, ${cfg.label}`}
    >
      <RIcon icon={cfg.Icon} size={12} color={cfg.color} />
      <Typography
        sx={{
          fontFamily: 'PremierLeagueBold',
          fontSize: '0.62rem',
          lineHeight: 1,
          color: cfg.color,
          letterSpacing: '0.08em',
          textTransform: 'uppercase',
          whiteSpace: 'nowrap',
        }}
      >
        {cfg.label}
      </Typography>
      <Typography
        sx={{
          fontFamily: 'PremierLeagueBold',
          fontSize: '1.05rem',
          lineHeight: 1,
          color,
        }}
      >
        {score}
      </Typography>
    </Box>
  )
}

export default InterestScoreBadge
